import Styles from '../assets/styles.scss';
import { IChatSection } from '../entities/IChatSection';

const ChatSection: React.FC<IChatSection> = props => {
	return <div className={Styles.chat}>{props.children}</div>;
};

export { ChatSection };
